import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, Flame } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

export default function Join() {
  const [params] = useSearchParams();
  const referredBy = params.get("ref");
  const [form, setForm] = useState({ name: "", email: "", phone: "", rides: "", bio: "", instagram: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) { toast.error("Name and email are required"); return; }
    setLoading(true);
    try {
      await api.post("/applications", {
        name: form.name, email: form.email, phone: form.phone, rides: form.rides,
        bio: form.bio, socials: { instagram: form.instagram }, referred_by: referredBy || null,
      });
      setDone(true);
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  if (done) return (
    <div className="max-w-lg mx-auto px-5 py-24 text-center">
      <CheckCircle2 className="mx-auto text-[#4ade80] mb-4" size={60} />
      <h1 className="headline text-4xl text-[#f7f3ec] mb-3">Application Received!</h1>
      <p className="text-[#d6cec2]">The I-65 Ryders will review your application and reach out soon. Different trails, same family.</p>
    </div>
  );

  return (
    <div className="relative">
      <div className="relative py-16 grain overflow-hidden">
        <img src="/assets/join_hero.png" alt="I-65 Ryders on the trail at sunset" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#121110]/88" />
        <div className="relative z-10 max-w-2xl mx-auto px-5 text-center">
          <p className="eyebrow text-[#f3c649] text-sm mb-3 flex items-center justify-center gap-2"><Flame size={16} /> Exclusive, but always welcoming</p>
          <h1 className="headline text-4xl sm:text-6xl gold-text">WANT TO JOIN THE I-65 RYDERS FAMILY?</h1>
          <p className="text-[#d6cec2] mt-4 text-lg">We're accepting new members. Tell us about yourself and what you ride.</p>
        </div>
      </div>

      <form onSubmit={submit} className="max-w-xl mx-auto px-5 py-12 space-y-4" data-testid="join-form">
        {[
          { k: "name", label: "Full Name *", ph: "Your name" },
          { k: "email", label: "Email *", ph: "you@email.com", type: "email" },
          { k: "phone", label: "Phone", ph: "(000) 000-0000" },
          { k: "rides", label: "What do you ride?", ph: "ATV, Horse, Motorcycle, Custom Truck..." },
          { k: "instagram", label: "Instagram", ph: "@yourhandle" },
        ].map((f) => (
          <div key={f.k}>
            <label className="eyebrow text-xs text-[#d4af37] block mb-1.5">{f.label}</label>
            <input type={f.type || "text"} value={form[f.k]} onChange={set(f.k)} placeholder={f.ph} className="w-full bg-[#1a1816] border border-[#3a332c] rounded-xl px-4 py-3 text-[#f7f3ec] placeholder:text-[#6b645b] focus:border-[#e0481f] outline-none" data-testid={`join-${f.k}`} />
          </div>
        ))}
        <div>
          <label className="eyebrow text-xs text-[#d4af37] block mb-1.5">Tell us about yourself</label>
          <textarea value={form.bio} onChange={set("bio")} rows={4} placeholder="Why do you want to ride with the I-65 Ryders?" className="w-full bg-[#1a1816] border border-[#3a332c] rounded-xl px-4 py-3 text-[#f7f3ec] placeholder:text-[#6b645b] focus:border-[#e0481f] outline-none resize-none" data-testid="join-bio" />
        </div>
        <button disabled={loading} className="w-full btn-ember rounded-full py-4 font-display uppercase tracking-wider text-lg flex items-center justify-center gap-2 disabled:opacity-60" data-testid="join-submit">
          {loading ? <Loader2 className="animate-spin" size={18} /> : null} Submit Application
        </button>
      </form>
    </div>
  );
}
